import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dayforceKeys } from './keys'
import {
  createWorkerSubmissionRequest,
  type CreateWorkerSubmissionRequest,
} from 'api/admin/dayforce/createWorkerSubmissionRequest'

export const useCreateWorkerSubmissionRequestMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: CreateWorkerSubmissionRequest) =>
      createWorkerSubmissionRequest(request),
    onSuccess: async () =>
      queryClient.invalidateQueries({
        queryKey: dayforceKeys.all,
      }),
  })
}
